module.exports = __webpack_public_path__ + "fonts/ralewaysemibolditalic.9f178ab.woff2";